module.exports = __webpack_public_path__ + "img/KRT.a3bc4e95.png";